import React, { useEffect } from "react";
import "../style/ToastNotifications.css";
import "../styles/GlobalModal.css";

function ConfirmModal({ 
  isOpen, 
  onConfirm, 
  onCancel, 
  title = "Confirm Delete",
  message = "Are you sure you want to delete this customer? This action cannot be undone.",
  confirmText = "Delete",
  cancelText = "Cancel"
}) {
  useEffect(() => {
    if (isOpen) {
      // Hide sidebar when modal opens
      const sidebar = document.querySelector('.sidebar');
      if (sidebar) {
        sidebar.style.visibility = 'hidden';
        sidebar.style.opacity = '0';
        sidebar.style.pointerEvents = 'none';
      }
      
      // Prevent body scroll
      document.body.style.overflow = 'hidden';
    } else {
      // Show sidebar when modal closes
      const sidebar = document.querySelector('.sidebar');
      if (sidebar) {
        sidebar.style.visibility = 'visible';
        sidebar.style.opacity = '1';
        sidebar.style.pointerEvents = 'auto';
      }
      
      // Restore body scroll
      document.body.style.overflow = 'auto';
    }

    // Cleanup function
    return () => {
      const sidebar = document.querySelector('.sidebar');
      if (sidebar) {
        sidebar.style.visibility = 'visible';
        sidebar.style.opacity = '1';
        sidebar.style.pointerEvents = 'auto';
      }
      document.body.style.overflow = 'auto';
    };
  }, [isOpen]);

  if (!isOpen) return null;

  return (
    <div className="modal-backdrop" onMouseDown={(e) => e.target === e.currentTarget && onCancel()}>
      <div className="modal-content" style={{ width: 'min(480px, 95vw)', height: 'auto', maxHeight: '90vh' }}>
        <div className="modal-header">
          <div className="modal-header-title">
            <div className="modal-header-icon">
              ⚠️
            </div>
            <div className="modal-header-text">
              <h2>{title}</h2>
            </div>
          </div>
          <div className="modal-header-actions">
            <button className="modal-close-btn" onClick={onCancel}>
              ×
            </button>
          </div>
        </div>
        
        <div className="modal-body">
          <p>{message}</p>
        </div>
        
        <div className="modal-footer">
          <button 
            className="modal-btn"
            onClick={onCancel}
          >
            {cancelText}
          </button>
          <button 
            className="modal-btn"
            onClick={onConfirm}
            style={{ background: '#dc2626', color: '#fff' }}
          >
            {confirmText}
          </button>
        </div>
      </div>
    </div>
  );
}

export default ConfirmModal;
